<template>
  <div>
    <head-nav-bar
      title="订单管理"
      :fixed="true"
      rightText="筛选"
      @click-right="onSearchClick"
    />
    <div class="mt-header-nav">
      <van-search
        placeholder="请输入房号/入住人/订单号/手机号等"
        style="border-bottom:1px solid #f1f1f1;"
        show-action
        shape="round"
        v-model="keyword"
        @search="onSearch"
      >
        <div slot="action" @click="onSearch">搜索</div>
      </van-search>
      <van-tabs
        v-model="tabName"
        @change="onTabClick"
        :swipe-threshold="swipeThreshold"
        title-active-color="#098ae8"
      >
        <van-tab
          v-for="(item, index) in tabArr"
          :key="index"
          :title="item.title"
          :name="item.name"
        />
      </van-tabs>
      <div style="height:calc(100vh - 195px)" class="order-list">
        <DataList :api="getList" :params="params">
          <template v-slot:item="item">
            <div @click="orderDetail(item.Id, item.CompanyId)">
              <van-row>
                <van-col span="16" class="col-left">
                  <van-tag color="#199ed8" v-if="item.Status == 0">订</van-tag>
                  <van-tag v-else-if="item.Status == 1" color="#00cc99">
                    住
                  </van-tag>
                  <van-tag v-else-if="item.Status == 2" color="#fc0">
                    完
                  </van-tag>
                  <van-tag v-else-if="item.Status == 3" color="#d544ff"
                    >离
                  </van-tag>
                  <van-tag v-else-if="item.Status == 4" color="#999">
                    取
                  </van-tag>
                  <span class="item-name">
                    {{ item.CompanyName }}
                  </span>
                  <span
                    style="font-size: 12px;color:#999999"
                    v-if="item.ChannelName"
                  >
                    | {{ item.ChannelName }}
                  </span>
                </van-col>
                <van-col span="8" class="col-right">
                  <van-icon name="star" size="18" v-if="item.HasContacted" />
                  <van-icon
                    name="phone"
                    size="18"
                    v-if="item.Phone"
                    @click.stop="onCall(item.Phone)"
                  />
                </van-col>
              </van-row>

              <van-row class="time">
                <van-col span="16" class="col-left">
                  入离时间：{{ item.CheckInDate }} | {{ item.CheckOutDate }}
                </van-col>
                <van-col span="4" class="col-right">
                  共{{ item.RoomCount }}间
                </van-col>
                <van-col span="4" class="col-right">
                  共{{ diffDay(item) }}晚
                </van-col>
              </van-row>

              <van-row class="orderNo">
                <van-col span="12" class="col-left">
                  订单号：{{ item.No }}
                </van-col>
                <van-col span="12" class="col-right">
                  {{ item.OrderTime }}
                </van-col>
              </van-row>
            </div>
          </template>
        </DataList>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import searchPopup from "@/components/searchPopup";
import DataList from "@/components/DataList";
import GroupOrderApi from "../../api/group_order.js";
import { getGSelectData } from "../../api/common";
import moment from "moment";
import { tag, Search, Tab, Tabs, Row, Col, Icon, Dialog } from "vant";
export default {
  name: "GroupOrderPage",
  components: {
    DataList,
    [Search.name]: Search,
    [tag.name]: tag,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Row.name]: Row,
    [Col.name]: Col,
    [Icon.name]: Icon,
    [Dialog.Component.name]: Dialog.Component,
  },
  props: {},
  data() {
    return {
      getList: GroupOrderApi.GetGroupOrderPageList,
      keyword: "",
      params: {},
      tabName: "-1",
      swipeThreshold: 5,
      tabArr: [
        { name: "-1", title: "全部" },
        { name: "0", title: "预订" },
        { name: "1", title: "在住" },
        { name: "3", title: "暂离" },
        { name: "2", title: "完成" },
        { name: "4", title: "取消" },
      ],
      channelArr: [],
      companyArr: [],
    };
  },
  model: {},
  created() {
    this.init();
    const orderId = this.$route.query.id;
    this.params = {
      OrderId: orderId,
    };
  },
  mounted() {},
  computed: {
    ...mapState({
      user: state => state.user.info,
    }),
  },
  watch: {},
  methods: {
    init() {
      getGSelectData({ Types: "company,companychannel" }).then(res => {
        this.channelArr = res.Data.companychannel;
        this.companyArr = res.Data.company;
      });
    },
    onSearchClick() {
      const AccountDate = this.user.AccountDate;
      searchPopup({
        title: "筛选",
        styles: {
          width: "90%",
        },
        content: [
          {
            label: "订单时间",
            name: "Date",
            type: "dateRange",
            props: {
              defaultValue: [
                moment(AccountDate)
                  .add(-10, "d")
                  .format("YYYY-MM-DD"),
                moment(AccountDate)
                  .add(10, "d")
                  .format("YYYY-MM-DD"),
              ],
            },
          },
          {
            label: "门店",
            name: "CompanyId",
            type: "buttonSelect",
            props: {
              valueField: "Id",
              textField: "Text",
              defaultValue: "",
            },
            data: this.companyArr,
          },
          {
            label: "渠道",
            name: "ChannelId",
            type: "buttonSelect",
            props: {
              valueField: "Id",
              textField: "Text",
              defaultValue: "",
            },
            data: this.channelArr,
          },
        ],
        submit: values => {
          let params = {
            CompanyId: values.CompanyId ? values.ChannelId : null,
            BeginDate: values.Date ? values.Date[0] : null,
            EndDate: values.Date ? values.Date[1] : null,
            ChannelId: values.ChannelId ? values.ChannelId : null,
            OrderId: "",
          };
          this.params = { ...this.params, ...params };
        },
      });
    },
    onSearch() {
      this.params = {
        OrderId: "",
        KeyWord: this.keyword,
        Status: this.tabName == "-1" ? "" : this.tabName,
      };
    },
    onTabClick() {
      this.onSearch();
    },
    diffDay(item) {
      return moment(item.CheckOutDate).diff(moment(item.CheckInDate), "day");
    },
    onCall(phone) {
      // Dialog.confirm({
      //   title: "拨打订单用户电话",
      //   message: "是否拨打用户电话" + phone
      // })
      //   .then(() => {
      // on confirm
      window.location.href = "tel:" + phone;
      // })
      // .catch(() => {
      //   // on cancel
      // });
    },
    orderDetail(id, companyId) {
      this.$router.push({
        name: "GroupOrderDetail",
        query: { id: id, companyId: companyId },
      });
    },
  },
};
</script>

<style scoped>
.col-left {
  padding: 3px 0px 3px 17px;
}
.time {
  font-size: 12px;
  color: #999999;
}
.item-name {
  font-size: 16px;
}
.orderNo {
  font-size: 12px;
  color: #cccccc;
}
.col-right {
  padding: 3px 20px 3px 0px;
  text-align: right;
}
.order-list .list-item {
  border-bottom: 3px solid #f5f5f9;
  border-bottom: 0.08rem solid #f5f5f9;
}
</style>
